export const NAME = 'dashboards-structure';

export const views = {
	PPZ: 'PPZ',
	SELLER: 'SELLER',
	MANAGER: 'MANAGER',
	REGION: 'REGION',
	CENTRAL: 'CENTRAL',
	OVERVIEW: 'OVERVIEW',
};
